import type { getStorage } from 'reactApp/modules/storage/storage.helpers';
import type { StorageCurrentFolder } from 'reactApp/modules/storage/storage.selectors';

export interface IProps {
    folder: StorageCurrentFolder;
}

export interface IActionItem {
    title: string;
    annotation: string;
    className?: string;
    Icon?: JSX.Element;
    onClick?: () => void;
    additionLinks?: JSX.Element;
}

export enum EItemType {
    CREATE = 'create',
    COSHARING = 'cosharing',
    UPLOAD = 'upload',
    SELECT_FROM_CLOUD = 'upload-from-cloud',
    DOWNLOAD_APP = 'download-app',
    UPLOAD_ORIGINALS = 'upload-originals',
    CLIENT_SHARE = 'client-share',
    MEMORY = 'memory',
}

export type FolderStorageFlags = Partial<ReturnType<typeof getStorage>>;

export const gaSuffix = 'empty-folder';
